import { DEFAULT_DATE_FORMAT } from "@/constants";
import { formatDate } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface ContractorVisitDateProps {
  date?: string;
}

export const ContractorVisitDate = memo(
  ({ date }: ContractorVisitDateProps) => {
    const { t } = useTranslation();

    if (date === undefined) {
      return null;
    }

    return (
      <div className="flex flex-col mt-4 border rounded p-2 px-3">
        {t("projectContractorVisits.fields.date")}:
        <span className="text-lg flex items-center gap-2">
          <CalendarIcon strokeWidth={2.75} className="w-6 h-6" />
          <strong>{formatDate(date, DEFAULT_DATE_FORMAT)}</strong>
        </span>
      </div>
    );
  },
);
